var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bottomBar"}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"icon left"},[_c('router-link',{attrs:{"to":item.url}},[_c('img',{attrs:{"id":"guideIcon","src":_vm.active == item.url ? item.act : item.src}})])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }